// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ml-header-col[data-v-3df958b5] {\n  display: flex;\n  align-items: center;\n}\n.ml-header-col .ml-label[data-v-3df958b5] {\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
